import { requireNativeViewManager } from 'expo-modules-core';
import * as React from 'react';

import { V2rayModuleViewProps } from './V2rayModule.types';

const NativeView: React.ComponentType<V2rayModuleViewProps> =
  requireNativeViewManager('V2rayModule');

export default function V2rayModuleView(props: V2rayModuleViewProps) {
  return <NativeView name={props.name} />;
}
